import React from "react";
import LegalPage from "./LegalPage";

const blocks = [
  {
    heading: "Vos données, en toute transparence",
    paragraphs: [
      "Diallo attache une grande importance à la protection de vos données personnelles. Cette page explique quelles informations nous collectons et comment nous les utilisons.",
    ],
  },
  {
    heading: "Données collectées",
    paragraphs: [
      "Lorsque vous remplissez le formulaire « Devenir Diallo », nous collectons votre nom, votre numéro de téléphone, votre quartier/commune et votre message éventuel.",
      "Ces informations servent uniquement à vous recontacter au sujet de votre intérêt pour le réseau Diallo.",
    ],
  },
  {
    heading: "Utilisation & conservation",
    paragraphs: [
      "Vos données ne sont ni vendues ni cédées à des tiers. Elles sont conservées le temps nécessaire au traitement de votre demande, puis supprimées.",
    ],
  },
  {
    heading: "Vos droits",
    paragraphs: [
      "Vous pouvez demander l'accès, la rectification ou la suppression de vos données à tout moment en nous contactant via le formulaire de la page d'accueil.",
    ],
  },
  {
    heading: "Cookies",
    paragraphs: ["Ce site utilise des mesures d'audience anonymes pour améliorer l'expérience. Détails à compléter par l'éditeur."],
  },
];

export default function Confidentialite() {
  return <LegalPage testId="confidentialite-page" title="Politique de confidentialité" updated="à compléter" blocks={blocks} />;
}
